import React from 'react';

import AppProviders from '@/components/AppProviders';

export const wrapRootElement = ({ element }) => (
  <AppProviders>{element}</AppProviders>
);

export { wrapPageElement } from './src/utils/wrapPageElement';
